import useAdminModules from "./Modules";

const useAdmin = () => {
    return {
        useAdminModules
    };
}

export default useAdmin;